import { useState } from "react";
import { TiPlus } from "react-icons/ti";
import MealSelectionButton from "../../common/MealSelectionButton";
import mealTray from "../../../assets/images/tray2.png";
import { motion } from "framer-motion";
import {
  allMealsSelectedForDate,
  getDefaultFoodByDateAndTime,
  getFoodByDateAndTime,
  getPausedDates,
  hasDefaultFoodForDate,
  includesLongDate,
  is48HoursOrMore,
  isDayPassed,
  isSnack,
  cleanHTML,
  getDefaultFoodObjectByDateAndTime,
} from "../../utils/commonHelper";
import Modal from "../../common/Modal";
import { useGeneral } from "../../contexts/GeneralContext";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaBowlRice } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
const DayMealHolder = ({ activeWeek, customize, onUpdateMeals, paused }) => {
  const [editing, setEditing] = useState(null); // track which meal (date + type) is being edited
  const [defaultFood, setDefaultFood] = useState(null);
  const [show, setShow] = useState(false);
  const [showFood, setShowFood] = useState(false);
  const [showingFoodItem, setShowingFoodItem] = useState(null);
  const { extraContent } = useGeneral();
  const [activeIndexMap, setActiveIndexMap] = useState({});
  const handleSelect = (date, mealType, value) => {
    onUpdateMeals && onUpdateMeals(date, mealType, value);
    setEditing(null); // exit editing mode after selection
  };

  const toggleEdit = (date, mealTypeId) => {
    const key = `${date}-${mealTypeId}`;
    setEditing((prev) => (prev === key ? null : key));
  };
  const toggleDefault = (date, mealTypeId) => {
    const key = `${date}-${mealTypeId}`;
    setDefaultFood((prev) => (prev === key ? null : key));
  };
  const list = customize?.paused?.reactivationDate
    ? getPausedDates(
        customize?.paused?.pauseDate,
        customize?.paused?.reactivationDate
      )
    : [];

  return (
    <div className="flex flex-col gap-8 lg:gap-20 ">
      {customize?.remainingDaysDates
        ?.filter((day) => day.week === activeWeek)
        .map((day, index) => (
          <div
            key={index}
            className={`min-h-[187px]  rounded-[15px] relative flex flex-col items-center justify-center p-4
              ${
                isDayPassed(day?.date) || includesLongDate(list, day?.date)
                  ? " bg-gray "
                  : !is48HoursOrMore(day?.date)
                  ? "bg-gray/50"
                  : "bg-[#fff]"
              }`}
          >
            {/* Date label */}
            <div className="absolute left-0 -top-5 lg:-top-10 flex z-[11] items-center justify-center text-white text-20pt bg-orange text-nowrap rounded-[26px] px-7 py-1 lg:h-[53px] lg:min-w-[179px]">
              {day.date}
            </div>
            {is48HoursOrMore(day?.date) &&
              hasDefaultFoodForDate(customize?.foods, day?.date) &&
              !allMealsSelectedForDate(customize, day?.date) && (
                <div className="relative lg:absolute lg:right-2 top-2 z-[10] w-full flex items-start justify-end gap-1 text-secondary">
                  <BsFillInfoCircleFill
                    className="text-orange mt-[2px] shrink-0"
                    size={14}
                  />

                  <div className="text-[13px] font-mono text-orange max-w-[85%] leading-snug text-left">
                    Default meals are preselected, but you can update them to
                    the food items you prefer.
                  </div>
                </div>
              )}

            {includesLongDate(list, day?.date) && (
              <div className="absolute left-0 top-0 w-full h-full bg-gray/95 z-[10] rounded-[15px] flex items-center  p-10 text-secondary text-center justify-center">
                <div className="text-md xl:text-xl xl:mx-10">
                  This day has been paused by you. Meal selection and delivery
                  services are not available for this day.
                </div>
              </div>
            )}
            {isDayPassed(day?.date) && (
              <div className="absolute left-0 top-0 w-full h-full bg-gray/95 z-[10] rounded-[15px] flex items-center text-md xl:text-xl p-10 text-secondary text-center justify-center">
                This day has ended. Meal selection or modification is no longer
                available.
              </div>
            )}
            {/* Meal slots */}
            <div
              className={`grid w-full gap-6 justify-items-center ${
                customize?.subscribedMeals.length === 1
                  ? "grid-cols-1"
                  : customize?.subscribedMeals.length === 2
                  ? "md:grid-cols-2"
                  : customize?.subscribedMeals.length === 3
                  ? "md:grid-cols-3"
                  : "md:grid-cols-4"
              }`}
            >
              {customize?.subscribedMeals
                ?.sort((a, b) => a?.meal?.sortOrder - b?.meal?.sortOrder)
                .map((mealType, i) => {
                  const selectedMeal = customize?.selectedMeals?.find(
                    (sel) =>
                      sel.date === day.date &&
                      sel.meal?._id === mealType?.meal?._id
                  );

                  const key = `${day.date}-${mealType?.meal?._id}`;
                  const isEditing = editing === key;

                  return (
                    <div
                      key={i}
                      className={
                        includesLongDate(list, day?.date)
                          ? "flex flex-col items-center justify-center px-2 lg:px-10 hidden"
                          : isDayPassed(day?.date) || is48HoursOrMore(day?.date)
                          ? "flex flex-col items-center justify-center px-2 lg:px-10"
                          : "flex flex-col items-center justify-center px-2 lg:px-10 z-[30]"
                      }
                      // onClick={
                      //   is48HoursOrMore(day?.date)
                      //     ? () => null
                      //     : () => setShow(true)
                      // }
                    >
                      {!selectedMeal &&
                      defaultFood != `${day?.date}-${mealType?.meal?._id}` &&
                      getDefaultFoodByDateAndTime(
                        customize?.foods,
                        day?.date,
                        mealType?.meal?._id
                      ) != "" ? (
                        <div
                          className="relative w-[210px] h-[210px] md:w-[160px] md:h-[170px] xl:w-[200px] xl:h-[210px] bg-center bg-no-repeat bg-contain rounded-lg overflow-hidden my-0 md:my-3 lg:my-5"
                          style={{ backgroundImage: `url(${mealTray})` }}
                        >
                          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-2 ms-2">
                            <div className="text-green text-16pt xl:text-18pt leading-none mb-1 capitalize">
                              {isSnack(mealType?.meal?.title)
                                ? "Snacks"
                                : mealType?.meal?.title}
                            </div>
                            <div
                              onClick={() => {
                                setShowFood(true);
                                setShowingFoodItem(
                                  getDefaultFoodObjectByDateAndTime(
                                    customize?.foods,
                                    day?.date,
                                    mealType?.meal?._id
                                  )
                                );
                              }}
                              title="Click to view meal details"
                              className="text-16pt xl:text-18pt line-clamp-3 px-3 rounded-full leading-[21px] mx-3"
                            >
                              {getDefaultFoodByDateAndTime(
                                customize?.foods,
                                day?.date,
                                mealType?.meal?._id
                              )}
                            </div>
                          </div>
                          {is48HoursOrMore(day?.date) ? (
                            <button
                              className="absolute bottom-0 lg:bottom-3 left-1/2 transform -translate-x-1/2 bg-[#CC9965] text-white text-16pt xl:text-18pt font-mono px-3 rounded-[8px] text-nowrap transition"
                              onClick={() =>
                                toggleDefault(day.date, mealType?.meal?._id)
                              }
                            >
                              Default Meal
                            </button>
                          ) : (
                            <div
                              onClick={
                                is48HoursOrMore(day?.date)
                                  ? () => null
                                  : () => setShow(true)
                              }
                              className="absolute bottom-0 lg:bottom-3 left-1/2 transform -translate-x-1/2 bg-green hover:bg-[#347c2f] text-white text-16pt xl:text-18pt font-mono px-3 rounded-[8px] text-nowrap transition"
                            >
                              Confirmed
                            </div>
                          )}
                        </div>
                      ) : selectedMeal && !isEditing ? (
                        // ✅ Show selected meal tray (view mode)
                        <div
                          className="relative w-[210px] h-[210px] md:w-[160px] md:h-[170px] xl:w-[200px] xl:h-[210px] bg-center bg-no-repeat bg-contain rounded-lg overflow-hidden my-0 md:my-3 lg:my-5"
                          style={{ backgroundImage: `url(${mealTray})` }}
                        >
                          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-2 ms-2">
                            <div
                              onClick={() => {
                                setShowFood(true);
                                setShowingFoodItem(selectedMeal);
                              }}
                              title="Click to view meal details"
                              className="cursor-pointer text-green text-16pt xl:text-18pt leading-none mb-1 capitalize"
                            >
                              {isSnack(mealType?.meal?.title)
                                ? "Snacks"
                                : mealType?.meal?.title}
                            </div>
                            <div
                              onClick={() => {
                                setShowFood(true);
                                setShowingFoodItem(selectedMeal);
                              }}
                              title="Click to view meal details"
                              className="cursor-pointer hover:text-secondary/80 text-16pt xl:text-18pt line-clamp-3 px-3 rounded-full leading-[21px] mx-3"
                            >
                              {selectedMeal?.food?.title}
                            </div>
                          </div>
                          {is48HoursOrMore(day?.date) ? (
                            <button
                              className="absolute bottom-0 lg:bottom-3 left-1/2 transform -translate-x-1/2 bg-green hover:bg-[#347c2f] text-white text-16pt xl:text-18pt font-mono px-3 rounded-[8px] text-nowrap transition"
                              onClick={() =>
                                toggleEdit(day.date, mealType?.meal?._id)
                              }
                            >
                              Edit
                            </button>
                          ) : (
                            <div
                              onClick={
                                is48HoursOrMore(day?.date)
                                  ? () => null
                                  : () => setShow(true)
                              }
                              className="absolute bottom-0 lg:bottom-3 left-1/2 transform -translate-x-1/2 bg-green hover:bg-[#347c2f] text-white text-16pt xl:text-18pt font-mono px-3 rounded-[8px] text-nowrap transition"
                            >
                              Confirmed
                            </div>
                          )}
                        </div>
                      ) : defaultFood ===
                        `${day?.date}-${mealType?.meal?._id}` ? (
                        // 🧩 Select or Edit mode
                        <>
                          <p className="text-green  text-center text-21pt lg:text-24pt pt-4 2.5xl:pt-2 capitalize">
                            {isSnack(mealType?.meal?.title)
                              ? "Snacks"
                              : mealType?.meal?.title}
                          </p>
                          <MealSelectionButton
                            text={
                              !is48HoursOrMore(day?.date)
                                ? "Default Meal"
                                : selectedMeal
                                ? "Update"
                                : "Select"
                            }
                            icon={<TiPlus size={18} />}
                            options={getFoodByDateAndTime(
                              customize?.foods,
                              day?.date,
                              mealType?.meal?._id
                            )}
                            disabled={!is48HoursOrMore(day?.date)}
                            date={day?.date}
                            mealId={mealType?.meal?._id}
                            onSelect={handleSelect}
                            textColor="#fff"
                            bgColor="#295B24"
                          />
                          {defaultFood ===
                            `${day?.date}-${mealType?.meal?._id}` && (
                            <button
                              title="Click to cancel edit"
                              className="text-sm text-orange mt-2 hover:text-underline"
                              onClick={() =>
                                toggleDefault(day.date, mealType?.meal?._id)
                              }
                            >
                              Cancel
                            </button>
                          )}
                          {selectedMeal && (
                            <button
                              title="Click to cancel edit"
                              className="text-sm text-orange mt-2 hover:text-underline"
                              onClick={() =>
                                toggleEdit(day.date, mealType?.meal?._id)
                              }
                            >
                              Cancel
                            </button>
                          )}
                        </>
                      ) : (
                        // 🧩 Select or Edit mode
                        <>
                          <p className="text-green  text-center text-21pt lg:text-24pt pt-4 2.5xl:pt-2 capitalize">
                            {isSnack(mealType?.meal?.title)
                              ? "Snacks"
                              : mealType?.meal?.title}
                          </p>
                          <MealSelectionButton
                            text={
                              !is48HoursOrMore(day?.date)
                                ? "Default Meal"
                                : selectedMeal
                                ? "Update"
                                : "Select"
                            }
                            icon={<TiPlus size={18} />}
                            options={getFoodByDateAndTime(
                              customize?.foods,
                              day?.date,
                              mealType?.meal?._id
                            )}
                            disabled={!is48HoursOrMore(day?.date)}
                            date={day?.date}
                            mealId={mealType?.meal?._id}
                            onSelect={handleSelect}
                            textColor="#fff"
                            bgColor={
                              !is48HoursOrMore(day?.date)
                                ? "#CC9965"
                                : "#295B24"
                            }
                          />
                          {defaultFood ===
                            `${day?.date}-${mealType?.meal?._id}` && (
                            <button
                              title="Click to cancel edit"
                              className="text-sm text-orange mt-2 hover:text-underline"
                              onClick={() =>
                                toggleDefault(day.date, mealType?.meal?._id)
                              }
                            >
                              Cancel
                            </button>
                          )}
                          {selectedMeal && (
                            <button
                              title="Click to cancel edit"
                              className="text-sm text-orange mt-2 hover:text-underline"
                              onClick={() =>
                                toggleEdit(day.date, mealType?.meal?._id)
                              }
                            >
                              Cancel
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
      <Modal
        isOpen={showFood}
        onClose={() => setShowFood(false)}
        closeOnOutClick={true}
        title={""}
        showConfirm={false}
        showCancel={false}
        customClass="xl:max-w-[70%] max-h-[80%] overflow-scroll"
      >
        {showingFoodItem?.meal?.title?.toLowerCase() != "lunch" && (
          <>
            <p className="text-34pt text-left leading-none mb-4">
              {showingFoodItem?.food?.title}
            </p>

            <div className="group relative bg-white rounded-xl flex flex-col md:flex-row items-start gap-4 text-left">
              {/* Left info */}
              <div className="flex-1 w-full">
                <div className="flex items-center flex-wrap gap-3 mb-3">
                  {showingFoodItem?.food?.vegOrNonVeg && (
                    <span
                      className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.food?.vegOrNonVeg === "Veg"
                          ? "bg-green/10 text-green"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      <span
                        className={`w-2.5 h-2.5 me-1 rounded-full ${
                          showingFoodItem?.food?.vegOrNonVeg === "Veg"
                            ? "bg-green/80"
                            : "bg-red-600"
                        }`}
                      ></span>
                      {showingFoodItem?.food?.vegOrNonVeg}
                    </span>
                  )}

                  {showingFoodItem?.food?.hotOrCold && (
                    <span
                      className={`text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.food?.hotOrCold === "Hot"
                          ? "bg-orange/20 text-orange"
                          : "bg-blue-100 text-blue-500"
                      }`}
                    >
                      {showingFoodItem?.food?.hotOrCold}
                    </span>
                  )}

                  {showingFoodItem?.food?.nutritionalInfo && (
                    <div className="flex flex-wrap gap-2">
                      {showingFoodItem?.food?.nutritionalInfo
                        .split(",")
                        .map((nutri, idx) => (
                          <span
                            key={idx}
                            className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                          >
                            {nutri.trim()}
                          </span>
                        ))}
                    </div>
                  )}
                </div>

                {/* Allergens */}
                {showingFoodItem?.food?.allergens?.filter(
                  (a) => a.trim() !== ""
                ).length > 0 && (
                  <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                    <motion.span
                      animate={{
                        rotate: [0, -10, 10, -10, 0],
                        scale: [1, 1.15, 1.05, 1.15, 1],
                      }}
                      transition={{
                        duration: 1.4,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      className="text-orange text-xl"
                    >
                      ⚠️
                    </motion.span>

                    <p className="text-orange text-18pt font-sans">
                      Allergens:{" "}
                      {showingFoodItem?.food?.allergens
                        .filter((a) => a.trim() !== "")
                        .join(", ")}
                    </p>
                  </div>
                )}

                {/* Description */}
                <div className="text-sm text-gray-700 mt-4 leading-relaxed  ">
                  {showingFoodItem?.food?.ingredients && (
                    <p className="text-24pt font-mono flex items-center flex-wrap gap-0 w-full">
                      <FaBowlRice size={24} className="text-quaternary me-2" />
                      <span className="font-sans  leading-relaxed">
                        Ingredients:
                      </span>
                      <span className="leading-[35px] text-[22px] capitalize w-full">
                        {showingFoodItem?.food?.ingredients}
                      </span>
                    </p>
                  )}
                  {showingFoodItem?.food?.description && (
                    <p
                      className="subtitle text-24pt abouthtml1 font-mono "
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(showingFoodItem?.food?.description),
                      }}
                    />
                  )}
                </div>
              </div>

              {/* ------- Image Swiper ------- */}
              <div
                // title="Click to enlarge image"
                className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                // onClick={() => handleShowModal(mealItem)}
              >
                <Swiper
                  modules={[Pagination, Autoplay]}
                  pagination={{ clickable: true }}
                  autoHeight={true}
                  className="w-full h-full review small"
                  onSlideChange={(s) => {
                    setActiveIndexMap((prev) => ({
                      ...prev,
                      [showingFoodItem?.food?._id]: s.realIndex,
                    }));
                  }}
                >
                  {/* Main Image */}
                  {showingFoodItem?.food?.image && (
                    <SwiperSlide
                      key="main"
                      className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10 hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.food?.image}`}
                        alt={showingFoodItem?.food?.title}
                        onError={(e) => {
                          e.currentTarget.src = require("../../../assets/images/link.png");
                          e.currentTarget.classList.add("object-contain");
                        }}
                        className="w-full h-[200px] object-contain bg-gray rounded-lg"
                      />
                    </SwiperSlide>
                  )}

                  {/* Extra Images */}
                  {Array.isArray(showingFoodItem?.food?.pictures) &&
                    showingFoodItem?.food?.pictures
                      .slice(0, 2)
                      .map((img, i) => (
                        <SwiperSlide
                          key={i}
                          className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10"
                        >
                          <img
                            src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                            alt={showingFoodItem?.food?.title}
                            onError={(e) => {
                              e.currentTarget.src = require("../../../assets/images/link.png");
                              e.currentTarget.classList.add("object-contain");
                            }}
                            className="w-full h-[200px] object-contain bg-gray rounded-lg"
                          />
                        </SwiperSlide>
                      ))}
                </Swiper>
              </div>
            </div>
          </>
        )}
        {showingFoodItem?.meal?.title?.toLowerCase() === "lunch" && (
          <>
            <div
              key={showingFoodItem?.food?._id}
              className="group relative   bg-white rounded-xl  gap-4 text-left "
            >
              {/* Left info */}

              <div className="flex flex-col md:flex-row  lg:items-start justify-between gap-6">
                <div className="flex-1 w-full">
                  <p className="text-32pt mb-4">
                    {showingFoodItem?.food?.title}
                  </p>
                  <div className="flex items-center flex-wrap gap-3 mb-3">
                    {showingFoodItem?.food?.vegOrNonVeg && (
                      <span
                        className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.food?.vegOrNonVeg === "Veg"
                            ? "bg-green/10 text-green"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        <span
                          className={`w-2.5 h-2.5 me-1 rounded-full ${
                            showingFoodItem?.food?.vegOrNonVeg === "Veg"
                              ? "bg-green/80"
                              : "bg-red-600"
                          }`}
                        ></span>
                        {showingFoodItem?.food?.vegOrNonVeg}
                      </span>
                    )}

                    {showingFoodItem?.food?.hotOrCold && (
                      <span
                        className={`text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.food?.hotOrCold === "Hot"
                            ? "bg-orange/20 text-orange"
                            : "bg-blue-100 text-blue-500"
                        }`}
                      >
                        {showingFoodItem?.food?.hotOrCold}
                      </span>
                    )}

                    {showingFoodItem?.food?.nutritionalInfo && (
                      <div className="flex flex-wrap gap-2">
                        {showingFoodItem?.food?.nutritionalInfo
                          .split(",")
                          .map((nutri, idx) => (
                            <span
                              key={idx}
                              className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                            >
                              {nutri.trim()}
                            </span>
                          ))}
                      </div>
                    )}
                  </div>

                  {/* Allergens */}
                  {showingFoodItem?.food?.allergens?.filter(
                    (a) => a.trim() !== ""
                  ).length > 0 && (
                    <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                      <motion.span
                        animate={{
                          rotate: [0, -10, 10, -10, 0],
                          scale: [1, 1.15, 1.05, 1.15, 1],
                        }}
                        transition={{
                          duration: 1.4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-orange text-xl"
                      >
                        ⚠️
                      </motion.span>

                      <p className="text-orange text-18pt font-sans">
                        Allergens:{" "}
                        {showingFoodItem?.food?.allergens
                          .filter((a) => a.trim() !== "")
                          .join(", ")}
                      </p>
                    </div>
                  )}

                  {/* Description */}
                </div>

                {/* ------- Image Swiper ------- */}
                <div
                  // title="Click to enlarge image"
                  className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                  // onClick={() => handleShowModal(showingFoodItem)}
                >
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    autoHeight={true}
                    className="w-full h-full review small"
                    onSlideChange={(s) => {
                      setActiveIndexMap((prev) => ({
                        ...prev,
                        [showingFoodItem?.food?._id]: s.realIndex,
                      }));
                    }}
                  >
                    {/* Main Image */}
                    {showingFoodItem?.food?.image && (
                      <SwiperSlide
                        key="main"
                        className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative  hover:shadow-lg transition-shadow ${
                          showingFoodItem?.food?.pictures?.length > 0
                            ? "pb-10"
                            : ""
                        }`}
                      >
                        <img
                          src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.food?.image}`}
                          alt={showingFoodItem?.food?.title}
                          onError={(e) => {
                            e.currentTarget.src = require("../../../assets/images/link.png");
                            e.currentTarget.classList.add("object-contain");
                          }}
                          className="w-full h-[200px] object-contain bg-gray rounded-lg"
                        />
                      </SwiperSlide>
                    )}

                    {/* Extra Images */}
                    {showingFoodItem?.food?.pictures &&
                      Array.isArray(showingFoodItem?.food?.pictures) &&
                      showingFoodItem?.food?.pictures
                        ?.slice(0, 2)
                        .map((img, i) => (
                          <SwiperSlide
                            key={i}
                            className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative ${
                              showingFoodItem?.food?.pictures.length > 0
                                ? "pb-10"
                                : ""
                            }`}
                          >
                            <img
                              src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                              alt={showingFoodItem?.food?.title}
                              onError={(e) => {
                                e.currentTarget.src = require("../../../assets/images/link.png");
                                e.currentTarget.classList.add("object-contain");
                              }}
                              className="w-full h-[200px] object-contain bg-gray rounded-lg"
                            />
                          </SwiperSlide>
                        ))}
                  </Swiper>
                </div>
              </div>

              <div
                className={`text-sm text-gray-700 leading-relaxed ${
                  showingFoodItem?.food?.pictures?.length > 0
                    ? "mt-10 "
                    : "mt-4  "
                }`}
              >
                {showingFoodItem?.food?.description && (
                  <p
                    className={`subtitle text-24pt  font-mono ${"abouthtml1"}`}
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML(showingFoodItem?.food?.description),
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </Modal>
      <Modal
        isOpen={show}
        onClose={() => setShow(false)}
        title={"Meal Changes Locked Within 48 Hours"}
        onConfirm={() => setShow(false)}
        showConfirm={false}
        showCancel={false}
      >
        <div className="font-mono">
          <p className="mt-2">
            {extraContent?.mealChangesLockedMessages?.line_1 ||
              "Meals can be customized up to 48 hours before their scheduled date. Meals within the next 48 hours can no longer be edited. If you’ve already made a selection, Nutricub will deliver your chosen meal; otherwise, a default meal will be provided for that day."}
          </p>
          <p className="mt-2">
            {extraContent?.mealChangesLockedMessages?.line_2 ||
              "Meals can be customized up to 48 hours before their scheduled date. Meals within the next 48 hours can no longer be edited. If you’ve already made a selection, Nutricub will deliver your chosen meal; otherwise, a default meal will be provided for that day."}
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default DayMealHolder;
